import { TrustConfigTypes } from "./types/trust-config-types";

export const TrustConfig: TrustConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
